import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

console.log('=== SUPABASE INITIALIZATION ===');
console.log('Supabase URL:', supabaseUrl ? `${supabaseUrl?.substring(0, 30)}...` : 'MISSING');
console.log('Supabase Anon Key:', supabaseAnonKey ? `${supabaseAnonKey?.substring(0, 20)}...` : 'MISSING');

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ CRITICAL: Missing Supabase environment variables');
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

console.log('✅ Supabase environment variables loaded');

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'gridbalance-auth-token',
    flowType: 'pkce'
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-my-custom-header': 'dealership-management'
    }
  }
});

console.log('✅ Supabase client created successfully');
console.log('Client auth methods available:', {
  signInWithPassword: typeof supabase?.auth?.signInWithPassword,
  signOut: typeof supabase?.auth?.signOut,
  getSession: typeof supabase?.auth?.getSession,
  onAuthStateChange: typeof supabase?.auth?.onAuthStateChange
});
console.log('================================\n');